import React from 'react';
import PropTypes from 'prop-types';
import { PLATE_SIZES } from 'src/constants/forms';

import PlateDisplayComponent from './PlateDisplayComponent';

const getWellsMatrixData = (plateSize, wells) => {
  const wellsMatrixConfig = [];

  if (!plateSize || !wells) {
    return wellsMatrixConfig;
  }

  // matrixSize = [lines, columns]
  const matrixSize = plateSize === PLATE_SIZES.SIZE_96 ? [8, 12] : [16, 24];
  // rows number to letters array
  const rows = [...Array(matrixSize[0]).keys()].map((i) => String.fromCharCode(i + 1 + 64));
  // columns number to numbers array
  const columns = [...Array(matrixSize[1]).keys()].map((i) => i + 1);

  rows.forEach((rowItem, rowIdx) => {
    wellsMatrixConfig[rowIdx] = [];

    columns.forEach((colItem, colIdx) => {
      const wellItem = wells.find(
        (well) => well.row === rowItem && well.column === colItem
      ) || {};

      wellsMatrixConfig[rowIdx][colIdx] = {
        row: rowItem,
        column: colItem,
        // isValid = null means no data for that specific well (well doens't exist)
        isValid: null,
        ...wellItem
      };
    });
  });

  return wellsMatrixConfig;
};

const PlateDisplayContainer = ({ plateSize, wells, onWellClick: propsOnWellClick }) => {
  const wellsMatrixConfig = React.useMemo(
    () => getWellsMatrixData(plateSize, wells),
    [plateSize, wells]
  );
  const onWellClick = (well) => {
    if (well.isValid === null) {
      return;
    }

    propsOnWellClick(well);
  };

  return (
    <PlateDisplayComponent
      {...{
        plateSize,
        wellsMatrixConfig,
        onWellClick,
        condensed: plateSize === PLATE_SIZES.SIZE_384,
      }}
    />
  );
};

PlateDisplayContainer.propTypes = {
  plateSize: PropTypes.number,
  wells: PropTypes.array.isRequired,
  onWellClick: PropTypes.func.isRequired,
};

export default PlateDisplayContainer;
